import * as React from 'react'

import { sharedSlidesBaseSrc, } from '../constants'

const logoSrc = `${sharedSlidesBaseSrc}/quill_logo.svg`

const FinalSlide = ({ getPremiumCredit, }) => {
  return (
    <section className="slide final-slide" key="final-slide">
      <img alt="" src={logoSrc} />
      <h1>Our non-profit commitment to you</h1>
      <p>Whether your students are learning to write, writing to learn, or both, Quill can help them on their journey to become confident, effective writers ready to succeed in college, career, and life.</p>
      <span className="divider" />
      <p><b>To that end, Quill promises:</b></p>
      <ul>
        <li><span>Our activities will always be free</span></li>
        <li><span>Our AI will always be developed and used ethically</span></li>
        <li><span>Our curriculum will always be teacher-built</span></li>
        <li><span>Our mission will never change</span></li>
      </ul>
      <button className="quill-button contained extra-large green focus-on-light" onClick={getPremiumCredit} type="button">Claim your free month of Teacher Premium</button>
    </section>
  )
}

export default FinalSlide
